import Vue from 'vue'

/**
 * Vue ApexCharts
 *
 * Registro global asíncrono: apexcharts es una librería pesada usada solo en el
 * dashboard y el reporte de proveedores. Cargándola de forma diferida sale del
 * bundle inicial. Las plantillas siguen usando <apexchart> sin cambios.
 */
Vue.component('apexchart', () => import(/* webpackChunkName: "apexcharts" */ 'vue-apexcharts'))
